document.addEventListener("DOMContentLoaded", function () {
  /**
   * Transition to elements on visible
   */
  const elements = document.querySelectorAll(".reveal");

  const elObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("appear");

          // Trigger only once
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -15% 0px",
    },
  );

  elements.forEach((el) => elObserver.observe(el));

  document.querySelectorAll(".swiper-slide-active .reveal").forEach((el) => {
    el.classList.add("appear");
    elObserver.unobserve(el);
  });

  /**
   * Add custom navigation for testimonials slider
   */
  const slider = document.querySelector(".wpbingo-about--testimonials .js-carousel");

  if (slider) {
    // Wait for Slick initialization
    const waitForSlick = setInterval(() => {
      if (slider.classList.contains("slick-initialized")) {
        clearInterval(waitForSlick);
        initCustomSlideArrows(slider);
      }
    }, 200);

    function initCustomSlideArrows(slider) {
      slider.addEventListener("click", (e) => {
        const nextBtn = e.target.closest(".slide-next");
        const prevBtn = e.target.closest(".slide-prev");

        if (nextBtn) {
          e.preventDefault();
          $(slider).slick("slickNext");
        }

        if (prevBtn) {
          e.preventDefault();
          $(slider).slick("slickPrev");
        }
      });
    }
  }

  /**
   * Header top bar - change the season icon and text
   */
  const currentMonth = new Date().getMonth();

  const currentSeason =
    currentMonth >= 2 && currentMonth <= 4
      ? "spring"
      : currentMonth >= 5 && currentMonth <= 7
        ? "summer"
        : currentMonth >= 8 && currentMonth <= 10
          ? "autumn"
          : "winter";
  $(".bwp-header-campar .marquee_text_content .season").text(currentSeason);

  var seasonIcon = "https://www.tendtomygarden.com/cdn/shop/files/Spring-Icon.svg";

  if (currentSeason == "summer") {
    seasonIcon = "https://www.tendtomygarden.com/cdn/shop/files/Summer-Icon.svg";
  } else if (currentSeason == "autumn") {
    seasonIcon = "https://www.tendtomygarden.com/cdn/shop/files/Autumn-Icon.svg";
  } else if (currentSeason == "winter") {
    seasonIcon = "https://www.tendtomygarden.com/cdn/shop/files/Winter-Icon.svg";
  }

  $(".bwp-header-campar .marquee_text_content .icon img").attr("src", seasonIcon);

  /**
   * Remove nordpass icon from the browser
   */
  const nordPassObserver = new MutationObserver(() => {
    document.querySelectorAll("nordpass-icon").forEach((icon) => icon.remove());
  });

  nordPassObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /**
   * Enable focus on elements only when navigating through keyboard
   */

  let usingKeyboard = false;

  document.addEventListener("keydown", function (e) {
    // Ignore modifier keys
    if (["Tab", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Enter", " ", "Escape"].includes(e.key)) {
      usingKeyboard = true;
      document.documentElement.classList.add("using-keyboard");
    }
  });

  document.addEventListener("mousedown", function () {
    usingKeyboard = false;
    document.documentElement.classList.remove("using-keyboard");
  });

  document.addEventListener("pointerdown", function () {
    usingKeyboard = false;
    document.documentElement.classList.remove("using-keyboard");
  });
});
